import { getCurrentInstance, inject } from 'vue'

import type { NotifierOptions, ToastOptions } from '@R/types/toastTypes'

import useToast from './useToast'

// export const NotifierSymbol: InjectionKey<ReturnType<typeof useNotifier>> = Symbol.for('vuetify:notifier')

export const useNotifier = (_options: any = {}) => {
    const v = getCurrentInstance()
    if (!v) {
        throw new Error(`[Notifier] useNotifier() must be called from inside a setup function`)
    }

    const config = inject('notifier') as NotifierOptions

    function toast(options: Partial<ToastOptions> = {}) {
        return useToast().add(options)
    }
    return {
        toast,
        config,
    }
}